import product from "./product";

export default {
    product,

    noAvailableItems: "Não há produtos disponíveis para encomenda."
}